export default __webpack_public_path__ + "static/media/PearlConnectLogo.7320f78a.svg";